const listContent = {
  namespaced: true,
  state: {
    listContent: "",
    isShowContent: false,
  },
  mutations: {
    updateListContent(state, data) {
      state.listContent = data;
    },
  },
};

export default listContent;
